module.exports = __webpack_public_path__ + "img/ph.d5bcc73d.svg";